<template>
  <div id="app">
      <router-view />
      <CustomerService />
  </div>
</template>
<script>
import CustomerService from './components/CustomerService/index.vue'
export default {
  name: 'App',
  components: {
    CustomerService
  }
}

</script>
<style>

</style>
